import { WORDMARK } from '@/constants/assets';
import { company } from '@/libs/company';

// viewBox del wordmark oficial (kit v1.2 de bison-design: lienzo 520×150) — evita CLS
// reservando el ancho correcto.
const WORDMARK_RATIO = 520 / 150;

/**
 * Wordmark de Bison — solo la imagen. El wrapper (Link / layout) lo pone el
 * consumidor, que la estiliza vía su propio CSS module.
 * dark=true → variante para fondos oscuros (Bison teal + agents blanco);
 * dark=false → variante para fondos claros (Bison teal oscuro + agents ink).
 */
export default function Logo({ dark = false, height = 36 }) {
  return (
    <img
      src={dark ? WORDMARK.onDark : WORDMARK.onLight}
      alt={`Logo de ${company.name}`}
      height={height}
      width={Math.round(height * WORDMARK_RATIO)}
      // El lienzo del kit deja 30 de 150 de margen a la izquierda: se compensa para alinear con el texto.
      style={{ marginLeft: -Math.round((height * 30) / 150) }}
    />
  );
}
